import React, { useEffect } from 'react';

import { NavigationWrapper } from '../NavigationWrapper';
import {
  Loading,
  SectionsWrapper,
} from '../EnvironmentSetup/EnvironmentSetup.styles';
import { AzureDevOpsSection } from './AzureDevOpsSection';
import { DataBricksSection } from './DataBricksSection';
import { StorageSection } from './StorageSection';
import { ReportServiceSection } from './ReportServiceSection';
import {
  fetchSettings,
  selectSettings,
  useAppDispatch,
  useAppSelector,
} from '../../../state';
import { DataFactorySection } from './DataFactorySection';

export const BackEndAccess = () => {
  const settingsData = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      !settingsData.settings &&
      !settingsData.loading &&
      !settingsData.failed
    ) {
      dispatch(fetchSettings());
    }
  }, []);

  if (settingsData.loading) {
    return <Loading />;
  }

  if (settingsData.failed) {
    return (
      <SectionsWrapper>
        Error loading data. Please try again later.
      </SectionsWrapper>
    );
  }

  return (
    <>
      <NavigationWrapper />

      <SectionsWrapper disabled={settingsData.saving}>
        {settingsData.settings ? (
          <>
            <AzureDevOpsSection {...settingsData.settings} />
            <DataBricksSection {...settingsData.settings} />
            <StorageSection {...settingsData.settings} />
            <ReportServiceSection {...settingsData.settings} />
            <DataFactorySection {...settingsData.settings} />
          </>
        ) : (
          <div>no data</div>
        )}
      </SectionsWrapper>
    </>
  );
};
